import { render, staticRenderFns } from "./OrganizationSubHeader.vue?vue&type=template&id=517585a0&scoped=true&"
import script from "./OrganizationSubHeader.vue?vue&type=script&lang=js&"
export * from "./OrganizationSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSubHeader.vue?vue&type=style&index=0&id=517585a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517585a0",
  null
  
)

export default component.exports